import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: string;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  maxlength?: number;
  status?: "" | "error" | "warning";
  prefix?: string;
  suffix?: string;
  prefixIcon?: string;
  suffixIcon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InputDefault',
  props: {
    modelValue: { default: "" },
    placeholder: { default: "" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    maxlength: { default: undefined },
    status: { default: "" },
    prefix: { default: undefined },
    suffix: { default: undefined },
    prefixIcon: { default: "" },
    suffixIcon: { default: "" }
  },
  emits: ["update:modelValue", "blur", "pressEnter", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const innerValue = computed({
  get: () => props.modelValue ?? "",
  set: (val: string) => {
    emit("update:modelValue", val);
    emit("change", val);
  },
});

const onBlur = (e: FocusEvent) => emit("blur", e);
const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: innerValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((innerValue).value = $event)),
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    maxlength: _ctx.maxlength,
    status: _ctx.status,
    prefix: _ctx.prefix,
    suffix: _ctx.suffix,
    class: "ant-text-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, _createSlots({ _: 2 }, [
    (_ctx.prefixIcon)
      ? {
          name: "prefix",
          fn: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.prefixIcon)
            }, null, 2)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.suffixIcon)
      ? {
          name: "suffix",
          fn: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.suffixIcon)
            }, null, 2)
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["value", "placeholder", "disabled", "size", "allow-clear", "maxlength", "status", "prefix", "suffix"]))
}
}

})